import { useTranslations } from '@vocab/react';
import { Stack, Text, Tiles } from 'braid-design-system';

import translations from './.vocab';
import { Section } from '../../common/section/Section';
import type { Award as AwardType } from '../../../';
import { awardImage } from './Awards.css';

const MAX_AWARDS = 12;

interface Props {
  mode: 'view' | 'edit';
  model?: AwardType[];
}

const Award = ({ description, imageUrl }: Omit<AwardType, 'year'>) => (
  <Stack space="small">
    <img src={imageUrl} className={awardImage} alt={description} />
    <Text weight="medium">{`${description}`}</Text>
  </Stack>
);

export function AwardsSection({ mode, model }: Props) {
  const { t } = useTranslations(translations);

  const awards =
    model?.slice(0, MAX_AWARDS).sort((a, b) => b.year - a.year) || [];

  return (
    <Section mode={mode} heading={t('Awards & accreditations')}>
      <Tiles columns={[2, 3, 4]} space="gutter">
        {awards.map(({ description, imageUrl }, index) => (
          <Award key={index} description={description} imageUrl={imageUrl} />
        ))}
      </Tiles>
    </Section>
  );
}
